module.exports = __webpack_public_path__ + "static/media/facebookbannermobil.2d988187.png";